import { getCookie, removeCookie } from 'services/utils/CookieHandler'
import axios from 'axios'

// axios.defaults.baseURL = process.env.REACT_APP_BASE_URL

export async function get(url, setError) {

    const token = getCookie("loginData")

    const config = {
        headers: {
            "Authorization": `Bearer ${token?.accessToken}`,
        }
    }

    return await axios.get(url, config)
        .then(resposne => resposne.data)
        .catch(error => {console.log(error); setError(error)})

}
export async function post(url, data, attType, setError) {

    const token = getCookie("loginData")

    const config = {
        headers: {
            "Content-Type": attType ? "multipart/form-data" : "application/json",
            "Authorization": `Bearer ${token?.accessToken}`,
        }
    }

    return await axios.post(url, data, config)

        .then(resposne => resposne.data)
        .catch(error => {
            if(url.includes("extendtoken")) {
                if(error.response.status) {
                    removeCookie("loginData")
                }
            }
            console.log(error);
            setError(error)
        })
}
